import {
  FullpageLoading,
  Menu,
  SeatingPlan,
  SplBestSeatTabs,
} from "components";
import messages from "i18n/messages";
import first from "lodash/first";
import flowRight from "lodash/flowRight";
import { fetchDateById, makeSelectDateById } from "logic/dates";
import { makeSelectEventByDateId } from "logic/events";
import { makeSelectCurOrg } from "logic/orgs";
import { fetchSeatingPlanById } from "logic/spl";
import { clearCandidates } from "logic/orders";
import Head from "next/head";
import { Component } from "react";
import { Container } from "reactstrap";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createStructuredSelector } from "reselect";

class EventDateSplIndex extends Component {
  static async getInitialProps(ctx) {
    const { id } = ctx.query;
    ctx.store.dispatch(fetchDateById(id));

    return { pageProps: { id } };
  }

  componentDidMount() {
    this.props.actions.clearCandidates();
    this.fetchSpl();
  }

  componentDidUpdate() {
    this.fetchSpl();
  }

  fetchSpl = () => {
    if (!this.props.date) return;
    if (this.splFetched) return;

    this.props.actions.fetchSeatingPlanById(this.props.date.seating_plan_id);
    this.splFetched = true;
  };

  eventImgSrc = (event) =>
    event.images && first(event.images) ? first(event.images).thumb : null;

  eventBgImgstyles = (event) => ({
    backgroundImage: `url(${this.eventImgSrc(event)}`,
  });

  render() {
    const {
      event,
      org,
      date,
      intl: { formatMessage },
    } = this.props;
    if (!event || !org || !date) return <FullpageLoading />;

    return (
      <div>
        <Head>
          <title>{`${formatMessage(messages.ticketShop, org)}`}</title>
          <meta name="robots" content="noindex, nofollow" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          {date.wl && process.env.HZL_INST ? (
            <script src="https://wait.crowdhandler.com/js/latest/main.js?id=51ad7cc811dbddee06a69b798c26b4870b8a013151ccdf7128c74696c5d775cc"></script>
          ) : null}
        </Head>
        <Menu date={date} />
        <Container fluid className="booking-content">
          <SplBestSeatTabs date={date} org={org} spl />
          <SeatingPlan splId={date.seating_plan_id} />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
  date: makeSelectDateById((props) => props.id),
  event: makeSelectEventByDateId((props) => props.id),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchSeatingPlanById,
      fetchDateById,
      clearCandidates,
    },
    dispatch
  ),
});

const enhance = flowRight(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(EventDateSplIndex);
